/** Whether a credit payer can start AI work: EXHAUSTED once its balance is below one DOCUMENT_SCAN. */
export const CreditStatus = {
  AVAILABLE: 'AVAILABLE',
  EXHAUSTED: 'EXHAUSTED'
} as const;

export type CreditStatus = (typeof CreditStatus)[keyof typeof CreditStatus];

/** How far a credit payer has drawn its running period allotment. */
export const CreditUsageLevel = {
  OK: 'OK',
  LOW: 'LOW',
  EXHAUSTED: 'EXHAUSTED'
} as const;

export type CreditUsageLevel = (typeof CreditUsageLevel)[keyof typeof CreditUsageLevel];

/** Used share of the running period allotment, in percent, from which usage is LOW. */
export const CREDIT_LOW_USAGE_PERCENT = 80;

/** Usage alert thresholds, in percent of the plan-period allotment. */
export const CreditAlertThreshold = {
  /** The same 80 % from which usage reads as LOW. */
  WARNING: CREDIT_LOW_USAGE_PERCENT,
  /** The plan-period grant has nothing left. */
  EXHAUSTED: 100
} as const;

export type CreditAlertThreshold = (typeof CreditAlertThreshold)[keyof typeof CreditAlertThreshold];

/** Credits used at which `percent` is reached: ceil(percent × allotment / 100), in integers. */
export function thresholdCredits(percent: CreditAlertThreshold, allotment: number): number {
  // percent × allotment is an exact integer (< 2^53), so the division rounds only once.
  return Math.ceil((percent * allotment) / 100);
}
